import React, { useEffect, useState } from 'react';
import { Navigate, useRoutes, useNavigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import Cookies from 'js-cookie';
// layouts
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
//
import Login from './pages/Login';
import Driver from './pages/Driver';
import Vehicle from './pages/Vehicle';
import User from './pages/User';
import VerificationModule from './pages/VerificationModule';
import Scheduling from './pages/Scheduling';
import NotFound from './pages/Page404';
import UserBookings from './pages/Bookings';
import OperatorSelect from './pages/OperatorSelect';
import Passes from './pages/Passes';
import PromoCodes from './pages/PromoCodes';
import NotificationsCampaigns from './pages/Notifications'; // Add this import
import { auth } from './firebase';
import { getFirstEnabledModule, usePrivilege } from './PrivilegeContext';
import ProtectedRoute from './ProtectedRoute';
import Operators from './pages/Operators';

// ----------------------------------------------------------------------

export default function Router() {
  const { role, modules } = usePrivilege();

  const firstModule = getFirstEnabledModule(modules);
  const fallbackPath = '/login';
  const dashboardRedirect = firstModule ? `/dashboard/${firstModule.key}` : fallbackPath;

  // const navigate = useNavigate();
  // const email = Cookies.get('email');
  // const [indicator, setIndicator] = useState({
  //   dashboard: false,
  //   login: false
  // })

  // to call settingPage
  // useEffect(() => {
  // this function is to check if the user authenticate or not.
  // if authenticate (have value in cookies) it will navigate to
  //  onAuthStateChanged(auth, (user) => {
  //    console.log('userss', user);
  //    if (user) {
  //      navigate('/dashboard/app', { replace: true });
  //      setIndicator({
  //       dashboard: true,
  //       login: false
  //      })
  //    } else {
  //     navigate('/login', { replace: true });
  //     setIndicator({
  //       dashboard: false,
  //       login: true
  //      })
  //    }
  //  })
  //  return () => {
  //   unlisten();
  //  }
  // }, []);

  return useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        {
          path: 'drivers',
          element: (
            <ProtectedRoute allowedRoles={[900, 101, 111, 110, 102]} allowedModuleKey="driversModule" role={role} modules={modules}>
              <Driver />
            </ProtectedRoute>
          ),
        },
        {
          path: 'vehicles',
          element: (
            <ProtectedRoute allowedRoles={[900, 101, 111, 110, 102]} allowedModuleKey="vehiclesModule" role={role} modules={modules}>
              <Vehicle />
            </ProtectedRoute>
          ),
        },
        {
          path: 'users',
          element: (
            <ProtectedRoute allowedRoles={[900, 101]} allowedModuleKey="usersModule" role={role} modules={modules}>
              <User />
            </ProtectedRoute>
          ),
        },
        {
          path: 'verification',
          element: (
            <ProtectedRoute allowedRoles={[900, 101]} allowedModuleKey="verificationModule" role={role} modules={modules}>
              <VerificationModule />
            </ProtectedRoute>
          ),
        },
        {
          path: 'scheduling',
          element: (
            <ProtectedRoute allowedRoles={[900, 101, 111, 110, 102]} allowedModuleKey="schedulingModule" role={role} modules={modules}>
              <Scheduling />
            </ProtectedRoute>
          ),
        },
        {
          path: 'bookings',
          element:
  <ProtectedRoute allowedRoles={[900, 101, 111, 110, 102]} allowedModuleKey="bookingsModule" role={role} modules={modules}>
    <UserBookings />
  </ProtectedRoute>,
        },
        {
          path: 'operators',
          element:
  <ProtectedRoute allowedRoles={[900, 101]} allowedModuleKey="operatorsModule" role={role} modules={modules}>
    <Operators />
  </ProtectedRoute>,
        },
        {
          path: 'passes',
          element: (
            <ProtectedRoute allowedRoles={[900, 101, 111, 110, 102]} allowedModuleKey="passesModule" role={role} modules={modules}>
              <Passes />
            </ProtectedRoute>
          ),
        },
        {
          path: 'promoCodes',
          element: (
            <ProtectedRoute allowedRoles={[900, 101, 111, 110, 102]} allowedModuleKey="promoCodesModule" role={role} modules={modules}>
              <PromoCodes />
            </ProtectedRoute>
          ),
        },
        {
          path: 'notifications',
          element: (
            <ProtectedRoute allowedRoles={[900, 101, 111, 110]} allowedModuleKey="notificationsModule" role={role} modules={modules}>
              <NotificationsCampaigns />
            </ProtectedRoute>
          ),
        },
        {
          index: true,
          element: <Navigate to={dashboardRedirect} replace />,
        },
      ],
    },
    {
      path: '/',
      children: [
        { path: '/', element: <Navigate to={dashboardRedirect} replace /> },
        { path: 'login', element: <Login /> },
        { path: 'operator-select', element: <OperatorSelect /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/login" /> },
      ],
    },
    { path: '*', element: <Navigate to="/login" replace /> },
  ]);
}
